module.exports = __webpack_public_path__ + "img/main_banner_logo@2x.d26bded8.png";